const els = {
    $app: () => $('[data-properties-map]'),
    $map: () => els.$app().find('[data-map]'),
    $states: () => els.$app().find(`[data-state]`),
    $statesWithProperties: () => (
        els.$states().filter('[data-has-properties]')
    ),
    $state: (state) => (
        els.$states().filter(`[data-state="${state.toUpperCase()}"]`)
    ),
    $statePropertyCounts: () => (
        els.$app().find('[data-state-property-counts]')
    ),
    $statePropertyCount: (state) => (
        els.$app().find(`[data-state-property-count][data-for="${state}"]`)
    ),
    $stateDetails: () => els.$app().find('[data-state-details]'),
    $cityDropdown: () => els.$stateDetails().find('[data-city-dropdown]'),
    $cityDropdownMenu: () => els.$cityDropdown().find('[data-menu]'),
    $cityLayer: () => els.$map().find('[data-city-layer]'),
    $cities: () => els.$map().find(`[data-city]`),
    $city: (id) => els.$cities().filter(`[data-city="${id}"]`),
    $cityPopupLines: () => els.$cityLayer().find('[data-popup-line]'),
    $cityPopupLine: (id) => els.$city(id).find('[data-popup-line]'),
    $cityPopups: () => $('[data-city-popup]'),
    $cityPopup: (id) => $(`[data-city-popup="${id}"]`),
    $cityPopupCircle: (id) => els.$cityPopup(id).find('[data-circle]'),
    $cityPopupContent: (id) => els.$cityPopup(id).find('[data-content]'),
    $cityPopupPropertyLists: () => (
        $('[data-city-popup] [data-property-list]')
    ),
    $cityPopupPropertyList: (id) => (
        els.$cityPopupContent(id).find('[data-property-list]')
    ),
    $cityPopupPropertyListItems: (id) => (
        els.$cityPopupPropertyList(id).find('[data-property-list-item]')
    ),
    $cityPopupPropertyListItem: (cityId, propertyId) => (
        els.$cityPopupPropertyList(cityId)
            .find(`[data-property-list-item="${propertyId}"]`)
    ),
    $cityPopupPropertyListBookends: (id) => (
        els.$cityPopupPropertyList(id).find('[data-bookend]')
    ),
};

export default els;

